import React, { useMemo } from 'react'

import { isNativeShell, openExternal } from '../../lib/nativeShell'
import { renderChatMarkdown } from '../../utils/markdown'

/** In the native shell a link opens in the system browser, so the webview
 *  never navigates away from the app. Elsewhere the link stays a real link. */
function onLinkClick(event: React.MouseEvent<HTMLDivElement>) {
    if (!isNativeShell()) return
    if (event.defaultPrevented || event.button !== 0) return
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    const link = (event.target as Element).closest?.('a[href]') as HTMLAnchorElement | null
    if (!link || !event.currentTarget.contains(link)) return
    event.preventDefault()
    openExternal(link.href)
}

/** A chat message's text, rendered from Markdown in the page's theme
 *  (`.chat-md` in input.css). */
const ChatMarkdown: React.FC<{ text: string; streaming?: boolean }> = ({ text, streaming = false }) => {
    const html = useMemo(() => renderChatMarkdown(text, { streaming }), [text, streaming])
    return (
        <div
            className="chat-md prose prose-base max-w-none break-words"
            onClick={onLinkClick}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    )
}

export default React.memo(ChatMarkdown)
